// Notities (build 2.5): van een trainer, in clubs/{clubId}/notes/{noteId}:
//   { kind: "lesson" | "free", ownerUid, ownerName, shared, text, title,
//     lesson: planId, week, les (0 = Les A, 1 = Les B), lessonLabel, color,
//     createdAt, updatedAt }
// Een notitie bij een les heeft een vast id per trainer en les, zodat er per les één is.
// Privé ziet alleen de maker; gedeeld (alleen notities bij lessen) ziet de hele club.
import { db } from "../firebase";
import { collection, doc, getDocs, query, where, setDoc, deleteDoc, serverTimestamp } from "firebase/firestore";
import { cp } from "./data";

function col(clubId) { return collection(db, "clubs", clubId, "notes"); }

export async function loadNotes(clubId, uid) {
  var res = await Promise.all([
    getDocs(query(col(clubId), where("ownerUid", "==", uid))),
    getDocs(query(col(clubId), where("shared", "==", true))),
  ]);
  var map = {};
  res.forEach(function (snap) { snap.forEach(function (d) { map[d.id] = Object.assign({ id: d.id, saved: true }, d.data()); }); });
  return Object.keys(map).map(function (k) { return map[k]; });
}

export function lessonNoteId(uid, planId, week, les) {
  return (uid + "_" + planId + "_w" + week + "_" + (les ? "B" : "A")).replace(/[^A-Za-z0-9_-]/g, "_");
}
export function newNoteId(clubId) { return doc(col(clubId)).id; }

export async function saveNote(clubId, note) {
  var d = cp(note);
  ["id", "saved", "createdAt", "updatedAt", "updatedMs"].forEach(function (k) { delete d[k]; });
  d.updatedAt = serverTimestamp();
  if (!note.saved) d.createdAt = serverTimestamp();
  await setDoc(doc(db, "clubs", clubId, "notes", note.id), d, { merge: true });
}
export async function deleteNote(clubId, id) { await deleteDoc(doc(db, "clubs", clubId, "notes", id)); }

// Tijdstip om op te sorteren (lokaal gewijzigd of uit Firestore).
export function noteTime(n) {
  if (n.updatedMs) return n.updatedMs;
  var t = n.updatedAt;
  if (t && typeof t.toMillis === "function") return t.toMillis();
  if (t && t.seconds) return t.seconds * 1000;
  return 0;
}
var MONTHS = ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"];
var DAYS = ["zo", "ma", "di", "wo", "do", "vr", "za"];
export function noteDate(n) {
  var ms = noteTime(n);
  if (!ms) return "";
  var d = new Date(ms), now = new Date();
  if (d.toDateString() === now.toDateString()) return "vandaag";
  var y = new Date(now); y.setDate(now.getDate() - 1);
  if (d.toDateString() === y.toDateString()) return "gisteren";
  return DAYS[d.getDay()] + " " + d.getDate() + " " + MONTHS[d.getMonth()] + (d.getFullYear() !== now.getFullYear() ? " " + d.getFullYear() : "");
}
